// src/App.js
import React, { Suspense, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import About from './components/About';
import Footer from './components/Footer';
import { SkeletonGrid } from './components/ui/skeleton';
import './index.css';
const Experience = React.lazy(() => import('./components/Experience'));
const Projects = React.lazy(() => import('./components/Projects'));
const Skills = React.lazy(() => import('./components/Skills'));
const Education = React.lazy(() => import('./components/Education'));
const Certifications = React.lazy(() => import('./components/Certifications'));
const Contact = React.lazy(() => import('./components/Contact'));

function App() {
  const [language, setLanguage] = useState('en');

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Helmet>
        <title>Matheus Pereira - Software Engineer</title>
        <meta name="description" content="Welcome to Matheus Pereira Gonsalves's portfolio website. Explore backend projects, skills, experience, and contact information." />
        <meta name="keywords" content="Matheus Pereira Gonsalves, Matheus Pereira, portfolio, Backend Engineer, Software Engineer, Node.js, TypeScript" />
        <meta name="author" content="Matheus Pereira Gonsalves" />
        <meta property="og:title" content="Matheus Pereira Gonsalves - Portfolio" />
        <meta property="og:description" content="Explore my backend projects, technical skills, and professional experience." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://github.com/Matheuspgonsalves" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Matheus Pereira Gonsalves - Portfolio" />
        <meta name="twitter:description" content="Explore my backend projects, technical skills, and professional experience." />
        <link rel="canonical" href="https://github.com/Matheuspgonsalves" />
        {/* SEO: Structured Data for Google */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "Matheus Pereira Gonsalves",
            "url": "https://github.com/Matheuspgonsalves",
            "sameAs": [
              "https://github.com/Matheuspgonsalves",
              "https://www.linkedin.com/in/matheuspereiragonsalves/"
            ],
            "jobTitle": "Backend Engineer",
            "description": "Portfolio website of Matheus Pereira Gonsalves. Backend projects, technical skills, experience, and contact information."
          }
        `}</script>
        {/* SEO: Robots meta tag */}
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header language={language} setLanguage={setLanguage} />
      <div className="main-content">
        <About language={language} />
        <Suspense fallback={<div className="container py-16"><SkeletonGrid count={6} /></div>}>
          <Experience language={language} />
          <Projects language={language} />
          <Skills language={language} />
          <Education language={language} />
          <Certifications language={language} />
          <Contact language={language} />
        </Suspense>
      </div>
      <Footer language={language} />
    </div>
  );
}

export default App;
